// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".panel_H9l4y::part(base) {\n  margin-top: 48px;\n}\n\n.persona_PkfPB {\n  --size: 28px;\n}", "",{"version":3,"sources":["webpack://./../../pmow-components/lib/Components/NavHeader/styles.module.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;;AAIA;EACI,YAAA;AADJ","sourcesContent":[".panel {\r\n    &::part(base) {\r\n        margin-top: 48px;\r\n    }\r\n}\r\n\r\n.persona {\r\n    --size: 28px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": "panel_H9l4y",
	"persona": "persona_PkfPB"
};
export default ___CSS_LOADER_EXPORT___;
